/* eslint-disable react/prop-types */
import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import {
  setTitleHeader,
  setDefaultStackOption,
  hasNoAccess,
} from '@global/helpers';
import { showPopup } from '@/store/modal';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import ActionButton from '@components/navbar/ActionButton';
import MoreButton from '@components/navbar/MoreButton';

import PromotionAccountScreen from '@/screens/setting/promotion-accounts/PromotionAccountScreen';
import PromotionAccountFormScreen from '@/screens/setting/promotion-accounts/PromotionAccountFormScreen';

const Stack = createStackNavigator();

const PromotionAccountNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();

  return (
    <Stack.Navigator
      initialRouteName="PromotionAccountScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="PromotionAccountScreen"
        component={PromotionAccountScreen}
        options={(props) => ({
          title: setTitleHeader('Promotion Account'),
          headerRight: () => {
            if (isWeb) {
              return <NotificationSettingButton {...props} />;
            }
            const hasAccess = !hasNoAccess([
              'superadmin',
              'sales_admin',
              'marketing_admin',
              'general',
              'promotor',
            ]);
            if (!hasAccess) {
              return false;
            }
            const menus = [
              {
                type: 'function',
                name: 'Add',
                callback: () =>
                  dispatch(
                    showPopup({
                      name: 'promotionAccountCreateOption',
                      value: true,
                    }),
                  ),
              },
            ];
            return <MoreButton menu={menus} {...props} />;
          },
        })}
      />
      <Stack.Screen
        name="PromotionAccountFormScreen"
        component={PromotionAccountFormScreen}
        options={(props) => {
          const route = props.route;
          const isEdit = !!(route.params && route.params.id);
          const isViewMode = !!(route.params && route.params.viewMode);
          let title;
          if (isViewMode) {
            title = route.params.titleScreen || 'Promotion Account';
          } else if (isEdit) {
            title = 'Edit Promotion Account';
          } else {
            title = 'Add Promotion Account';
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // navigate() (not pop) so back survives a browser refresh. On
                // edit, return to the record's detail (view mode); else the list.
                onPress={() =>
                  isEdit && !isViewMode
                    ? props.navigation.navigate('PromotionAccountFormScreen', {
                        ...route.params,
                        viewMode: true,
                      })
                    : props.navigation.navigate('PromotionAccountScreen')
                }
              />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : isViewMode &&
                !hasNoAccess([
                  'superadmin',
                  'sales_admin',
                  'marketing_admin',
                  'general',
                  'promotor',
                ]) ? (
                <ActionButton
                  icon={require('@assets/img/icons/edit-white.svg')}
                  onCallback={() =>
                    props.navigation.navigate('PromotionAccountFormScreen', {
                      titleScreen: route.params?.titleScreen,
                      id: route.params?.id,
                    })
                  }
                />
              ) : (
                false
              ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default PromotionAccountNavigator;
